import config from 'config';
import camelize from 'lodash/camelCase';

import { ProductCategory } from '~/shared/constants/products';
import { MODEL_SIZES_MAP } from '~/shared/utils/sizeConstants';

export default function useModelSizeLabel({
  model,
  sizeCategory,
  productCategoryIdList,
  tagIdList,
}) {
  const currentModelSizeKey = MODEL_SIZES_MAP[camelize(sizeCategory)]?.key;
  const currentModelSize = (model?.[currentModelSizeKey] || '').toUpperCase();
  let waistInseamSize;

  const isProductSXFBralette = productCategoryIdList?.includes(
    ProductCategory.bralette
  );

  const isProductBottomDenim = productCategoryIdList?.some((categoryId) =>
    [
      ProductCategory.mensBottomDenim,
      ProductCategory.womensBottomDenim,
    ].includes(categoryId)
  );

  if (isProductBottomDenim) {
    const denimSize = model?.denimSize;
    const denimInseam = model?.denimInseam;

    if (denimSize && denimInseam) {
      return `${denimSize} ${denimInseam}`;
    }
  }

  // savage bra display(not bralette) is cup/band size
  const braSizeParsing = config.get('public.brand.features.braSizeParsing');
  if (
    braSizeParsing &&
    currentModelSizeKey === MODEL_SIZES_MAP.sizeBra.key &&
    !isProductSXFBralette
  ) {
    return model?.braCup && model?.braBand
      ? `${model.braBand}${model.braCup.toUpperCase()}`
      : null;
  }

  // waist and inseam size
  if (model && currentModelSizeKey === MODEL_SIZES_MAP.sizeBottom.key) {
    const currentModelWaist = model[MODEL_SIZES_MAP.sizeWaist.key];
    const currentModelInseam = model[MODEL_SIZES_MAP.inseamLength.key];

    if (currentModelWaist) {
      waistInseamSize = `${currentModelWaist}`;
    }

    if (currentModelInseam) {
      waistInseamSize = waistInseamSize?.length
        ? `${waistInseamSize} x ${currentModelInseam}`
        : `${currentModelInseam}`;
    }
  }

  const onePieceModelSize = (
    model?.bottomSize ||
    model?.topSize ||
    '-'
  ).toUpperCase();

  const isProductOnePiece = productCategoryIdList?.includes(
    ProductCategory.dresses
  );
  const isProductUnderwear = productCategoryIdList?.includes(
    ProductCategory.underwear
  );

  const waistInseamDisplayTagId = config.get(
    'public.productTags.waistInseamDisplay'
  );
  const isTaggedWaistInseam = tagIdList.find(
    (tagId) => waistInseamDisplayTagId === tagId
  );

  let displaySize =
    isProductOnePiece || isProductUnderwear
      ? onePieceModelSize
      : currentModelSize;

  displaySize =
    isTaggedWaistInseam && waistInseamSize ? waistInseamSize : displaySize;

  return displaySize;
}
